import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, Checkbox } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const modalProps = {
  isBlocking: true,
  className: 'save-brand-list-dialog',
};

const dialogFooterStyles = {
  actionsRight: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .do-not-ask-again-checkbox': {
      padding: '5px 0',
    },
    '& .confirm-button': {
      marginRight: 4,
    },
  },
};

export const SaveDialog = (props) => {
  const { open, onConfirm, onDismiss } = props;
  const i18n = useContext(I18nContext);
  const [isDoNotAskAgain, setIsDoNotAskAgain] = useState(false);

  const dialogContentProps = {
    type: DialogType.normal,
    title: i18n.getString(_TL_('Save brand list')),
    closeButtonAriaLabel: i18n.getString(_TL_('Close')),
    subText: i18n.getString(_TL_('Once your brand list is saved, it’ll be automatically added to your shared library where you can edit it. Are you sure you want to save your brand list?')),
  };

  return (
    <Dialog
      hidden={!open}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={480}
    >
      <DialogFooter styles={dialogFooterStyles}>
        <Checkbox
          className="do-not-ask-again-checkbox"
          checked={isDoNotAskAgain}
          onChange={(_, checked) => setIsDoNotAskAgain(checked)}
          label={i18n.getString(_TL_('Don’t ask again'))}
        />
        <div>
          <PrimaryButton className="confirm-button" onClick={() => onConfirm({ isDoNotAskAgain })} text={i18n.getString(_TL_('Yes, save'))} />
          <DefaultButton className="cancel-button" onClick={onDismiss} text={i18n.getString(_TL_('No, cancel'))} />
        </div>
      </DialogFooter>
    </Dialog>
  );
};

SaveDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
